
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Getting-Started/Installation.html",
      function () {
        return require("private-next-pages/Getting-Started/Installation.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Getting-Started/Installation.html"])
      });
    }
  